enum Path {
  EXCLUIR_SESSAO_ROLOS = "/sessoes/:sessaoId/excluir",
  CONFERENCIA_CAMPO = "/conferencia-campo",
  CONFERENCIA_CAMPO_DETALHES = "/conferencia-campo/:fazendaId/mapa/:safraId/:tipoFazenda",
  RELATORIO_PADROES_HVI = "/padroes-hvi",
  COMERCIAL = "/comercial",
  COMERCIAL_DETALHES_CONTRATO = "/comercial/detalhes/:grupoClienteId",
  IMPORTACAO_ACTS = "/cadastro/acts/importacao",
  ESTOQUE_COMERCIAL = "/estoque/comercial",
  ESTOQUE_RELATORIO = "/estoque/relatorio",
  EMAILS_BENEFICIAMENTO_DIARIO = "/emails-beneficiamento-diario",
  CONFIGURACAO_ENVIO_EMAILS = "/envio-emails",
  EMAILS_CATEGORIZACAO_LOTES = "/emails-categorizacao-lotes",
  EMAILS_ENLONAMETO_ROLOS = "/emails-enlonamento-rolos",
  DIVERGENCIA_SESSOES = "/divergencia-em-sessoes",
  CARGA_EM_ANDAMENTO = "/portal-balanca/carga-em-andamento/:fazendaId/:patioId",
  FARDINHOS_NO_PORTO = "/comercial/fardinhos-no-porto",
  BENEFICIAMENTO = "/beneficiamento",
  FARDINHOS_NAO_CLASSIFICADOS = "/fardinhos-nao-classificados",
  ENTRADA_PRODUCAO = "/entrada-producao",
}

export default Path;
